import type { SchemaIndexEntryData } from 'app/schema/types';
import type { DataSearchResult, SearchResult } from 'app/universal-search/types';
import capitalize from 'lodash/capitalize';

export const dataResultToSearchResult = (dataResult: DataSearchResult): SearchResult => ({
  href: `{branchPath}/data/${dataResult.__typename}/${encodeURIComponent(dataResult._id)}`,
  type: dataResult.__typename,
  summary: dataResult.searchSummary
});

export const schemaIndexEntryToSearchResult = (schemaResult: SchemaIndexEntryData): SearchResult => ({
  href: `{branchPath}/api/${schemaResult.type}/${schemaResult.name}`,
  type: capitalize(schemaResult.type),
  summary: schemaResult.name
});
